import { navigateTo, useRoute } from '#imports'
import { ref, watch } from 'vue'

export function useSellerFilter() {
  const filterReviewsByCurrentSeller = ref(false)
  const route = useRoute()

  watch(
    () => route.query,
    () => {
      const { seller_public_id: merchantId } = route.query

      filterReviewsByCurrentSeller.value = !!merchantId
    },
    { immediate: true },
  )

  async function resetSellerFilter() {
    await navigateTo({
      ...route,
      hash: route.hash,
      query: { ...route.query, seller_public_id: undefined },
    })
  }

  return {
    filterReviewsByCurrentSeller,
    resetSellerFilter,
  }
}
